module.exports = __webpack_public_path__ + "static/media/emily.k.lewis-IG.2ae67d9a.PNG";